import type { ColumnDef } from '@tanstack/react-table';
import { styled } from '@meterup/atto';

import { AutoTableWithState } from './AutoTable';
import { TablePaginationEnhanced } from './TablePagination/TablePagination';

const PaginationContainer = styled('div', {
  padding: '$12',
  display: 'flex',
  justifyContent: 'flex-end',
});

export function AutoTableWithPagination<D, C extends ColumnDef<D, any>>(
  props: Parameters<typeof AutoTableWithState<D, C>>[0],
) {
  const { tableState } = props;
  return (
    <>
      <AutoTableWithState {...props} />
      {tableState.numRows > tableState.limit && (
        <PaginationContainer>
          <TablePaginationEnhanced tableState={tableState} />
        </PaginationContainer>
      )}
    </>
  );
}
